import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Masonry from 'react-masonry-css';
import { getAllCareers } from '../../../../../api/career/career.api';
import ResumePlusCard from '../../../../Career/Default/ResumePlusCard';
import ResumeCard from './ResumeCard';

const AllResumeCard = ({
  sortBy,
  onStandardSuccess,
  onDeleteSuccess,
  $isMobile,
}) => {
  const navigate = useNavigate();
  const [resumeData, setResumeData] = useState([]);

  const fetchCareers = async () => {
    try {
      const data = await getAllCareers();
      setResumeData(data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    fetchCareers();
  }, []);

  const handleCreate = () => {
    navigate('/career/resumes/new?source=career_all_page_plus_btn');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const breakpointColumnsObj = {
    default: 3,
    1250: 2,
    850: 2,
  };

  const sortedData = [...resumeData].sort((a, b) => {
    if (sortBy === 'By Date') {
      return new Date(b.createdAt) - new Date(a.createdAt);
    }
    if (sortBy === 'By Completion') {
      return b.score - a.score;
    }
    return 0;
  });

  return (
    <div className=' w-full max-w-[1167px] mx-auto px-4 tabletH:p-0'>
      <Masonry
        breakpointCols={breakpointColumnsObj}
        className='flex w-full gap-4 tabletH:gap-[30px]'
        columnClassName='flex flex-col gap-4 tabletH:gap-[30px]'
      >
        <ResumePlusCard onClick={handleCreate} isMyPage className='w-full' />

        {sortedData.map((resume) => (
          <ResumeCard
            key={resume.id}
            resumeData={resume}
            onDeleted={() => fetchCareers()}
            onStandardSuccess={onStandardSuccess}
            onDeleteSuccess={onDeleteSuccess}
            onClick={() =>
              navigate(`/career/resumes/${resume.id}`, {
                state: {
                  title: resume.title,
                },
              })
            }
            $isMobile={$isMobile}
          />
        ))}
      </Masonry>
    </div>
  );
};

export default AllResumeCard;
